import { configureStore, Tuple } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";

import encodeSlice from "reducers/encodeSlice";
import encodeSagas from "sagas/encodeSagas";
import emailSlice from "reducers/emailSlice";
import emailSagas from "sagas/emailSagas";

const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
  reducer: {
    encode: encodeSlice.reducer,
    email: emailSlice.reducer,
  },
  middleware: () => new Tuple(sagaMiddleware),
});

sagaMiddleware.run(encodeSagas);
sagaMiddleware.run(emailSagas);

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;

export default store;
